import React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import type { Buttons } from '../../Header';
import DocumentTitleHeader from '../DocumentTitleHeader/DocumentTitleHeader';
import NavigationHeader from '../NavigationHeader/NavigationHeader';
import WizardHeader from '../WizardHeader/WizardHeader';

interface Props {
  title: React.ReactNode;
  buttons?: Buttons;
  backButtonDisabled: boolean;
  withImage?: boolean;
  showSGImage?: boolean;
  modal?: boolean;
  showNavigationHeader?: boolean;
  hideProgressBar?: boolean;
  handleExitPrompt: () => void;
  handleCloseClick: () => void;
  handleBackClick: () => void;
}

const HeaderComponent: React.FC<Props> = ({
  title,
  modal,
  buttons,
  backButtonDisabled,
  withImage = false,
  showSGImage = false,
  showNavigationHeader = true,
  hideProgressBar,
  handleExitPrompt,
  handleCloseClick,
  handleBackClick
}) => {
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const {
    data: { cmsHeaderAndGridLayout }
  } = useWizardContext();

  const getHeaderType = () => {
    if (isMobileEmbedded) {
      return <DocumentTitleHeader title={title} />;
    }
    if (cmsHeaderAndGridLayout && !modal) {
      return showNavigationHeader ? (
        <NavigationHeader
          title={title}
          buttons={buttons}
          backButtonDisabled={backButtonDisabled}
          handleBackClick={handleBackClick}
        />
      ) : null;
    }

    return (
      <WizardHeader
        title={title}
        modal={modal}
        buttons={buttons}
        withImage={withImage}
        showSGImage={showSGImage}
        backButtonDisabled={backButtonDisabled}
        hideProgressBar={hideProgressBar}
        handleBackClick={handleBackClick}
        handleCloseClick={handleCloseClick}
        handleExitPrompt={handleExitPrompt}
      />
    );
  };

  return getHeaderType() || null;
};

export default HeaderComponent;
